// extracted by mini-css-extract-plugin
module.exports = {"link":"NavItem_link__3UUH_","active":"NavItem_active__2lre1"};